import TopBar from "./TopBar";
import "./AboutTeachMeGo.css";

function AboutTeachMeGo() {
  const teamMembers = [
    {
      name: "Sbongiseni Mzizi",
      position: "Founding Director & Software Developer",
      bio: "Founder and software developer passionate about using technology to transform education.",
      image: "https://storage.googleapis.com/teachmego-f1353.firebasestorage.app/Founding%20Director.jpeg"
    }
    // Add more team members here as you grow
  ];

  return (
    <div className="about-container">
      <TopBar />
      
      <div className="about-content">
        {/* Hero Section */}
        <section className="about-hero">
          <div className="about-hero-content">
            <h1 className="about-title">About TeachMeGo</h1>
            <p className="about-subtitle">
              Revolutionizing education through personalized tutoring connections
            </p>
            <div className="hero-image">
              <img 
                src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" 
                alt="Students learning together" 
              />
            </div>
          </div>
        </section>

        {/* Mission & Vision Section */}
        <section className="mission-vision-section">
          <div className="mission-vision-grid">
            <div className="mission-card">
              <div className="card-image">
                <img 
                  src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                  alt="Team collaboration" 
                />
                <div className="image-overlay"></div>
              </div>
              <div className="card-content">
                <div className="card-icon">🎯</div>
                <h3>Our Mission</h3>
                <p>
                  To make quality education accessible to every student by connecting them with 
                  expert tutors through a seamless, reliable platform that understands their 
                  unique learning needs and academic goals.
                </p>
              </div>
            </div>
            
            <div className="vision-card">
              <div className="card-image">
                <img 
                  src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                  alt="Future vision" 
                />
                <div className="image-overlay"></div>
              </div>
              <div className="card-content">
                <div className="card-icon">🚀</div>
                <h3>Our Vision</h3>
                <p>
                  To become Africa's leading educational platform where every student can 
                  instantly find the perfect tutor, and every qualified educator can share 
                  their knowledge with those who need it most.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Story Section */}
        <section className="story-section">
          <div className="story-content">
            <div className="story-header">
              <h2>Our Story</h2>
              <div className="story-image">
                <img 
                  src="https://images.unsplash.com/photo-1523580494863-6f3031224c94?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                  alt="TeachMeGo story" 
                />
              </div>
            </div>
            <div className="story-text">
              <p>
                <strong>Priscilla</strong> is our mission to identify and solve gaps in education and communication. 
                Through research, innovation, and the power of AI, we explore ways to make learning and 
                support more accessible and effective for everyone.
              </p>
              <p>
                <strong>TeachMeGo</strong> is one of the solutions born from this vision. Built on the belief that 
                there is always someone ready to help, it connects students with qualified tutors 
                whenever they need assistance—whether it's 12 AM or on campus facing a tricky problem. 
                Just like how Uber connects riders and drivers instantly, TeachMeGo lets you request 
                a session and get help immediately.
              </p>
              <p>
                Through Priscilla, we continue to create platforms like TeachMeGo, bridging gaps in 
                education and transforming the way students access learning support.
              </p>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="values-section">
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-image">
                <img 
                  src="https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" 
                  alt="Quality education" 
                />
              </div>
              <div className="value-icon">⭐</div>
              <h4>Quality First</h4>
              <p>Every tutor is thoroughly vetted to ensure students receive the highest quality instruction.</p>
            </div>
            
            <div className="value-card">
              <div className="value-image">
                <img 
                  src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" 
                  alt="Instant access" 
                />
              </div>
              <div className="value-icon">⚡</div>
              <h4>Instant Access</h4>
              <p>Students can find and book tutors in real-time, eliminating waiting periods.</p>
            </div>
            
            <div className="value-card">
              <div className="value-image">
                <img 
                  src="https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" 
                  alt="Trust and safety" 
                />
              </div>
              <div className="value-icon">🤝</div>
              <h4>Trust & Safety</h4>
              <p>Secure platform with verified profiles and safe payment systems for all users.</p>
            </div>
            
            <div className="value-card">
              <div className="value-image">
                <img 
                  src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" 
                  alt="Growth mindset" 
                />
              </div>
              <div className="value-icon">🌱</div>
              <h4>Growth Mindset</h4>
              <p>We believe every student can achieve academic success with the right support.</p>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="team-section">
          <h2>Meet Our Team</h2>
          <p className="team-subtitle">
            Passionate individuals dedicated to transforming education
          </p>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-card">
                <div className="team-image">
                  <img src={member.image} alt={member.name} />
                  <div className="team-image-overlay"></div>
                </div>
                <div className="team-info">
                  <h3>{member.name}</h3>
                  <p className="team-position">{member.position}</p>
                  <p className="team-bio">{member.bio}</p>
                  <p className="team-contact">Email: mzizisbongiseni01@gmail.com</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Gallery Section */}
        <section className="gallery-section">
          <h2>Our Impact</h2>
          <p className="gallery-subtitle">Transforming education one session at a time</p>
          <div className="gallery-grid">
            <div className="gallery-item">
              <img 
                src="https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                alt="Student success" 
              />
              <div className="gallery-overlay">
                <span>Student Success Stories</span>
              </div>
            </div>
            <div className="gallery-item">
              <img 
                src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                alt="Learning environment" 
              />
              <div className="gallery-overlay">
                <span>Interactive Learning</span>
              </div>
            </div>
            <div className="gallery-item">
              <img 
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                alt="Team collaboration" 
              />
              <div className="gallery-overlay">
                <span>Community Building</span>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="about-cta">
          <div className="cta-content">
            <div className="cta-image">
              <img 
                src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" 
                alt="Join our community" 
              />
            </div>
            <div className="cta-text">
              <h2>Join the TeachMeGo Community</h2>
              <p>Whether you're a student seeking help or a tutor ready to share knowledge, your journey starts here.</p>
              <div className="cta-buttons">
                <a href="/auth" className="cta-btn primary">Find a Tutor</a>
                <a href="/contact" className="cta-btn secondary">Contact Us</a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default AboutTeachMeGo;
